import React from "react";
import PropTypes from "prop-types";
import { inject } from "mobx-react";
import { createUseStyles } from "react-jss";
import TariffDetailsList from "../TariffDetailsList";
import { UnlimitedSocialGrey } from "../UnlimitedSocialGrey";

const useStyles = createUseStyles({
	root: {
		display: "flex",
		flexDirection: "column",
	},
	tariffName: {
		display: "flex",
		justifyContent: "center",
		fontFamily: "Inter-Regular",
		color: "#111827",
		fontSize: "16px",
		lineHeight: "24px",
		textAlign: "center",
	},
	providerName: {
		fontFamily: "Inter-Regular",
		color: "#111827",
		fontSize: "12px",
		lineHeight: "16px",
		textAlign: "center",
		marginBottom: "8px",
	},
});

const TariffDetailsBlock = (props) => {
	const {
		ApplicationModel: { text },
		name,
		connection_price,
		calculation_connect,
		mobile,
		action,
		router,
		tvbox,
		sms,
		description,
		unlim,
		provider_name,
	} = props;
	const classes = useStyles();

	const socialData =
		unlim &&
		Object.entries(unlim)
			.filter(([, value]) => value === 1)
			.map(([key]) => ({
				key,
			}));

	return (
		<div className={classes.root}>
			<div className={classes.tariffName}>Тариф «{name}» от {provider_name}</div>
			{action && (
				<TariffDetailsList title={text.actions}>
					<div
						dangerouslySetInnerHTML={{
							__html: action,
						}}
					></div>
				</TariffDetailsList>
			)}
			{unlim && (
				<TariffDetailsList title={text.unlim_na_sim}>
					<UnlimitedSocialGrey socialData={socialData} />
				</TariffDetailsList>
			)}
			<TariffDetailsList title={text.connect_prepayment}>
				{connection_price === 0 ? (
					<div>{text.connect_free}</div>
				) : (
					<div>
						{text.connection_text_1} {connection_price} {text.connection_text_2}
					</div>
				)}

				{calculation_connect === 0 || !calculation_connect ? (
					<div>{text.prepayment_free}</div>
				) : (
					<div>
						{text.prepayment_text_1} {calculation_connect} {text.prepayment_text_2}
					</div>
				)}
			</TariffDetailsList>
			{router && (
				<TariffDetailsList title={text.router}>
					<div
						dangerouslySetInnerHTML={{
							__html: router,
						}}
					></div>
				</TariffDetailsList>
			)}
			{tvbox && (
				<TariffDetailsList title={text.tv_box}>
					<div
						dangerouslySetInnerHTML={{
							__html: tvbox,
						}}
					></div>
				</TariffDetailsList>
			)}
			<TariffDetailsList title={text.note}>
				{mobile?.calls !== 0 || mobile?.internet !== 0 || mobile?.sms !== 0 ?
					<div>На новую сим-карту можно перейти со своим номером мобильного телефона</div> :
					''
				}
				{sms && sms !== 0 && (
					<div>
						{text.sms_for_tariff} {sms}.
					</div>
				)}
				<div
					dangerouslySetInnerHTML={{
						__html: description,
					}}
				></div>
			</TariffDetailsList>
		</div>
	);
};

TariffDetailsBlock.propTypes = {
	name: PropTypes.string,
	connection_price: PropTypes.number,
	calculation_connect: PropTypes.number,
	exclusives_name: PropTypes.string,
	mobile: PropTypes.object,
	sms: PropTypes.number,
	router: PropTypes.string,
	tvbox: PropTypes.string,
	action: PropTypes.string,
	description: PropTypes.string,
	provider_name: PropTypes.string,
	unlim: PropTypes.object
};
export default inject("ApplicationModel")(TariffDetailsBlock);
